export default "__VITE_ASSET__DmzY5p5u__"